import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  removeReadOnlyFields,
  timestampToDate,
} from 'src/utils/fieldNormalizers';

import { Page } from './_types';

const readOnlyFields = ['created_at', 'updated_at'];

/**
 * Normalizes the page data received from the API to match the frontend model
 */
export const normalizePage = (data: any): Page => {
  const camelizedData = camelcaseKeys(data, { deep: true });

  return {
    id: camelizedData.id,
    name: camelizedData.name,
    cachedSlug: camelizedData.cachedSlug,
    content: camelizedData.content,
    platformId: camelizedData.platformId,
    createdAt: timestampToDate(camelizedData.createdAt),
    updatedAt: timestampToDate(camelizedData.updatedAt),
  };
};

/**
 * Denormalizes the page data to match the API expectations
 */
export const denormalizePage = (page: Partial<Page>): any => {
  const decamelized = decamelizeKeys(page, { deep: true });

  removeReadOnlyFields(decamelized, readOnlyFields);

  return decamelized;
};
